module.exports = __webpack_public_path__ + "static/media/item_33_8.39ac290e.png";